import { useState, useRef } from "react";
import { Row, Drawer, Button } from "rsuite";
import Hls from "hls.js";
import EyeRoundIcon from "@rsuite/icons/EyeRound";

function HlsDrawerPlayer({ src1, src2 }) {
  const [open, setOpen] = useState(false);
  const videoRef = useRef(null);
  const videoRef2 = useRef(null);

  const initHls = () => {
    if (videoRef.current) {
      if (Hls.isSupported()) {
        const hls = new Hls({
          // Increase buffer size and latency tolerance for live streaming
          maxBufferLength: 60, // increase buffer to 60 seconds
          maxMaxBufferLength: 120, // allow up to 2 minutes of buffer
          backBufferLength: 60, // increase back buffer to 60 seconds

          maxFragLookUpTolerance: 2.0,

          liveSyncDurationCount: 60, // stay ~1.5 segments behind live edge
          //liveMaxLatencyDurationCount: 40, // allow up to 10 segments of latency before dropping frames
          //maxLiveSyncPlaybackRate: 1.5, // speed up playback to catch up if we're too far behind
          debug: false,
        });
        hls.loadSource(src1);
        hls.attachMedia(videoRef.current);

        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          videoRef.current.muted = true; // required for autoplay
          videoRef.current.play();
        });

        const hls2 = new Hls({
          // Increase buffer size and latency tolerance for live streaming
          maxBufferLength: 60, // increase buffer to 60 seconds
          maxMaxBufferLength: 120, // allow up to 2 minutes of buffer
          backBufferLength: 60, // increase back buffer to 60 seconds

          maxFragLookUpTolerance: 2.0,

          liveSyncDurationCount: 60, // stay ~1.5 segments behind live edge
          //liveMaxLatencyDurationCount: 40, // allow up to 10 segments of latency before dropping frames
          //maxLiveSyncPlaybackRate: 1.5, // speed up playback to catch up if we're too far behind
          debug: false,
        });
        hls2.loadSource(src2);
        hls2.attachMedia(videoRef2.current);

        hls2.on(Hls.Events.MANIFEST_PARSED, () => {
          videoRef2.current.muted = true; // required for autoplay
          videoRef2.current.play();
        });
      } else if (
        videoRef.current.canPlayType("application/vnd.apple.mpegurl") //&&
        //videoRef2.current.canPlayType("application/vnd.apple.mpegurl")
      ) {
        // Safari/iOS native HLS
        videoRef.current.src = src1;
        videoRef2.current.src = src2;
      }
    }
  };

  return (
    <>
      <Row
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        paddingRight={"10px"}
        onClick={() => setOpen(true)}
      >
        <Button startIcon={<EyeRoundIcon />} appearance="primary" size="sm">
          Live Stream
        </Button>
      </Row>

      <Drawer
        size="70%"
        placement="right"
        open={open}
        onClose={() => setOpen(false)}
        onEntered={initHls} // initialize HLS only after drawer animation completes
      >
        <Drawer.Header>
          <Drawer.Title>Live Stream</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body style={{ backgroundColor: "#181818", color: "white" }}>
          {/* Fixed-size container prevents resize thrashing */}
          <div
            style={{
              backgroundColor: "#181818",
              width: "100%",
              height: "500px",
            }}
          >
            SSTD Camera 01 (Live)
            <video
              ref={videoRef}
              controls
              playsInline
              muted
              style={{
                width: "100%",
                height: "100%",
                display: "block",
                border: "1px solid #494949",
              }}
            />
          </div>
          <div style={{ height: "40px" }}></div>
          <div
            style={{
              backgroundColor: "#181818",
              width: "100%",
              height: "500px",
            }}
          >
            SSTD Camera 02 (Live)
            <video
              ref={videoRef2}
              controls
              playsInline
              muted
              style={{
                width: "100%",
                height: "100%",
                display: "block",
                border: "1px solid #494949",
              }}
            />
          </div>
        </Drawer.Body>
      </Drawer>
    </>
  );
}

export default HlsDrawerPlayer;
